var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",class:[`btn__${_vm.theme}`, `h-${_vm.size}`],on:{"click":function($event){$event.preventDefault();return _vm.eventClick.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }